module.exports = __webpack_public_path__ + "img/final_score_field.b45f7eff.jpg";